"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePostMerchantManagementV1CalculatorsCostSheetPrintMutation = exports.api = void 0;
const react_1 = require("@reduxjs/toolkit/query/react");
const config_1 = require("config");
const utils_1 = require("utils");
const baseQuery = (0, react_1.fetchBaseQuery)({
    baseUrl: config_1.REACT_APP_API_URL,
    prepareHeaders: async (headers) => {
        const accessToken = await utils_1.manageAuth0AccessToken.getAccessTokenSilently()();
        headers.set('Authorization', process.env.NODE_ENV === 'test' ? '' : `Bearer ${accessToken}`);
    },
});
const baseQueryWithCamelize = (0, utils_1.camelizeResponse)(baseQuery);
exports.api = (0, react_1.createApi)({
    reducerPath: 'merchantPortalApi',
    baseQuery: baseQueryWithCamelize,
    endpoints: (build) => ({
        //this endpoint is manually added to add the application/pdf header, but uses the codegen types
        postMerchantManagementV1CalculatorsCostSheetPrint: build.mutation({
            query: (queryArg) => ({
                url: `/merchant_management/v1/calculators/cost_sheet`,
                method: 'POST',
                body: queryArg.postMerchantManagementV1CalculatorsCostSheet,
                headers: {
                    accept: 'application/pdf',
                },
                responseHandler: async (response) => {
                    const blob = await response.blob();
                    const pdfWindowUrl = URL.createObjectURL(blob);
                    return { pdfWindowUrl };
                },
            }),
        }),
    }),
    keepUnusedDataFor: 0,
});
exports.usePostMerchantManagementV1CalculatorsCostSheetPrintMutation = exports.api.usePostMerchantManagementV1CalculatorsCostSheetPrintMutation;
